import React, { useState } from 'react';
import { FaImage } from 'react-icons/fa';
import { TYPE_LABELS } from '../utils';
import { getViewerPreviewUrl } from '../../../actions/infoTerminalViewer';
import styles from './styles.module.scss';

export default function InfoPanel({ object, allObjects, onNavigate, onClose, currentSchemaId }) {
  const [imgError, setImgError] = useState(false);
  const typeLabel = TYPE_LABELS[object.type] || object.type;
  const children = allObjects.filter(o => o.parent_id === object.id);

  const childLabel = {
    territory: 'Зданий',
    building: 'Этажей',
    floor: 'Помещений',
  }[object.type];

  const showImage = (object.type === 'building' || object.type === 'room') && object.id !== currentSchemaId;

  return (
    <aside className={`${styles.infoPanel} ${!showImage ? styles.compact : ''}`}>
      <div className={styles.infoPanelHeader}>
        <div>
          <div className={styles.infoPanelType}>{typeLabel}</div>
          <div className={styles.infoPanelName}>{object.name}</div>
        </div>
        <button className={styles.infoPanelClose} onClick={onClose}>×</button>
      </div>

      <div className={styles.infoPanelBody}>
        <div className={styles.bodyLayout}>
          {showImage && (
            <div className={styles.imageCol}>
              {object.has_image && !imgError ? (
                <img
                  className={styles.schemaImage}
                  src={getViewerPreviewUrl(object.id)}
                  alt={object.name}
                  onError={() => setImgError(true)}
                />
              ) : (
                <div className={styles.schemaImagePlaceholder}>
                  <FaImage size={24} />
                  <span>Изображение отсутствует</span>
                </div>
              )}
            </div>
          )}

          <div className={styles.metaCol}>
            <div className={styles.infoMeta}>
              <div className={styles.infoMetaItem}>
                <div className={styles.infoMetaLabel}>Тип</div>
                <div className={styles.infoMetaValue}>{typeLabel}</div>
              </div>

              {children.length > 0 && childLabel && (
                <div className={styles.infoMetaItem}>
                  <div className={styles.infoMetaLabel}>{childLabel}</div>
                  <div className={styles.infoMetaValue}>{children.length}</div>
                </div>
              )}

              {object.areas_count > 0 && (
                <div className={styles.infoMetaItem}>
                  <div className={styles.infoMetaLabel}>Областей</div>
                  <div className={styles.infoMetaValue}>{object.areas_count}</div>
                </div>
              )}

              {object.external_building?.short_title && (
                <div className={styles.infoMetaItem} style={{ gridColumn: '1 / -1' }}>
                  <div className={styles.infoMetaLabel}>Здание (УМБ)</div>
                  <div className={styles.infoMetaValue}>{object.external_building.short_title}</div>
                </div>
              )}

              {object.external_room?.name && (
                <div className={styles.infoMetaItem} style={{ gridColumn: '1 / -1' }}>
                  <div className={styles.infoMetaLabel}>Аудитория</div>
                  <div className={styles.infoMetaValue}>{object.external_room.name}</div>
                </div>
              )}
            </div>

            {object.description && (
              <p className={styles.infoDesc}>{object.description}</p>
            )}
          </div>
        </div>
      </div>

      {object.has_image && object.id !== currentSchemaId && (
        <div className={styles.infoPanelFooter}>
          <button className={styles.enterBtn} onClick={() => onNavigate(object)}>
            <span>↗</span> Перейти
          </button>
        </div>
      )}
    </aside>
  );
}
